module.exports = __webpack_public_path__ + "static/media/Strategi Session - Frågeformulär.61de0174.pdf";